<template>
  <div class="WeaveButton"> 

    <Description ref="description" indice="weaving" v-if="status != 'weave_completed'"/>

    <div ref="block" class="Bottom">

      <div 
        ref="sharing"
        class="Button sharing" 
        :class="{ 'regular': sharing == 17 }"
        @touchend="sharingCalled()"
        v-if="status == 'weave_completed'">
        Share Story
      </div> 

      <div ref="buttons" class="WeaveButton__buttons" v-if="sharing < 17">
        <div class="WeaveButton__reset" @touchstart="onReset()">
          
          <div class="WeaveButton__arrow">
            <svg viewBox="0 0 30.97 30.69">
             
             <path class="cls-11" d="M15.62,29.44A14.11,14.11,0,1,0,3.94,23.22"/>
             <polygon class="cls-12" points="7.42 28.66 7.67 20.7 0 25.77 7.42 28.66"/>
            </svg>
          </div>

        </div>
        <div 
          ref="button" 
          class="Button weave" 
          :class="{ over: over }" 
          @touchstart="onTouch(true)"
          @touchend="touchEnd(false)">
          <div class="WeaveButton__icon" :class="{ over: over }">  
            <svg viewBox="0 0 94.18 94.18">
              <path class="cls-3" d="M36.7,34.33l8.72-8.72a2.38,2.38,0,0,1,1.67-.69,2.31,2.31,0,0,1,1.55.58L38.25,35.88Z"/>
              <rect class="cls-3" x="44.16" y="37.66" width="14.69" height="2.19" transform="translate(115.34 29.73) rotate(135)"/>
              <rect class="cls-3" x="39.74" y="33.24" width="14.69" height="2.19" transform="translate(104.67 25.31) rotate(135)"/>
              <path class="cls-3" d="M58.29,38.24l1.55-1.55,8.73,8.73a2.38,2.38,0,0,1,.12,3.22Z"/>
              <rect class="cls-3" x="54.33" y="44.16" width="2.19" height="14.7" transform="translate(131.04 48.73) rotate(134.99)"/>
              <rect class="cls-3" x="58.75" y="39.74" width="2.19" height="14.7" transform="translate(135.46 38.06) rotate(134.99)"/>
              <rect class="cls-3" x="35.32" y="54.33" width="14.69" height="2.19" transform="translate(112.04 64.45) rotate(135)"/>
              <path class="cls-3" d="M47.09,69.26a2.33,2.33,0,0,1-1.54-.57L55.93,58.3l1.55,1.55-8.72,8.72A2.32,2.32,0,0,1,47.09,69.26Z"/>
              <rect class="cls-3" x="39.74" y="58.75" width="14.69" height="2.19" transform="translate(122.71 68.87) rotate(135)"/>
              <rect class="cls-3" x="37.68" y="35.31" width="2.19" height="14.77" transform="translate(96.39 45.47) rotate(135)"/>
              <path class="cls-3" d="M25.61,48.76a2.36,2.36,0,0,1-.69-1.67,2.29,2.29,0,0,1,.58-1.54L35.93,56l-1.55,1.55Z"/>
              <rect class="cls-3" x="33.26" y="39.73" width="2.19" height="14.77" transform="translate(-23.25 38.1) rotate(-45.01)"/>
            </svg>
          </div>
          <div>Weave</div>
          <div class="WeaveButton__right"/>
        </div>

      </div>

      <!-- 
      <div ref="button" class="Button" :class="{ over: over }" v-if="status =='continue'" @touchstart="onTouch(true)" @touchend="touchEnd(false)">
        {{ trans('GLOBAL.continue') }}
      </div> 
      -->

    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import Description from "./Description.vue"

export default {

  name: 'WeaveButton',
  components: { Description},
  data: ()=>({
    over: false,
    str: 0,
  }),
  computed: {
    status() { return this.$store.getters['app/status'] },
    touch_screen() { return this.$store.getters['app/touch_screen'] },
    sharing() { return this.$store.getters['app/line'] },
  },
  watch: { 
    touch_screen(nw, od) { 
      if(nw == false) {
        if(this.status =='continue')
          return
        this.over = false
      }
    }
  },

  mounted() {

    // window.alert(this.status)

    this.$nextTick(()=>{

      // console.log('if');

      if(this.status == 'continue'){
        gsap.set(this.$refs.description.$el, { opacity: 0 })
        gsap.from( this.$refs.button, { 
          duration: .5, 
          opacity: 0, 
          y: 200, 
          delay: 2.25, 
          ease: 'back.out' 
        })
      }
      else {

        // window.alert('else')

        let els = this.status != 'weave_completed'
                ? [ this.$refs.description.$el, this.$refs.buttons ]
                : [ this.$refs.sharing, this.$refs.buttons ]

        const del = status != 'weave_completed' ? .25 : 2.25

        gsap.from( els , {
          duration: .5, 
          opacity: 0, 
          y: 200, 
          delay: del, 
          stagger: .1,
          ease: 'back.out' 
        })

      }

    })




  },
  methods:{

    onReset() {
      this.$router.push({ params: { section: undefined } })
    },

    onTouch(b) {
      // if(this.status =='continue'){
      //   this.$router.push({ params: { section: 'story' } })
      //   // this.$store.commit('app/UPDATE_STATUS', 'weave_lines')
      //   return
      // }

      if(this.status !='continue')
        this.over = true
      this.$store.commit('app/TOUCH_SCREEN', b)

    },
    touchEnd(b) {

      if(this.status =='continue')
        return

      this.over = false
      this.$store.commit('app/TOUCH_SCREEN', b)
      gsap.delayedCall(.2, ()=>this.$store.commit('app/UPDATE_STATUS', 'weave_one'))
      
    },

    sharingCalled() {

      gsap.to( this.$el , {
        duration: .25, 
        opacity: 0, 
        y: 200, 
        ease: 'back.out',
        onComplete: ()=>{
          this.$router.push({ params: { section: 'story' } })
        } 
      })


      
    },
   

  }
}

</script>

<style lang="stylus">
@import '~@/config/Settings'

.WeaveButton
  position absolute
  color purple
  width 100%
  height 100%
  display flex
  flex-direction column
  align-items center
  justify-content flex-end
  z-index 600

  &__buttons
    display flex
    width 100%
    justify-content center

  &__reset 
    background red
    height 7vh
    width 7vh
    border-radius 8px
    border 2px solid purple
    margin-right 8px
    background purple
    display flex
    align-items center
    justify-content center
    color white

  &__title 
    width 70%
    text-align center
    font-family Raleway
    font-weight 500
    font-size 20px
    line-height 26px

  &__icon 
  &__right

    width 9vh
    height 9vh

    .cls-3
      fill #fff

    &.over 
      .cls-3
        fill purple

  .Button.sharing
    position absolute
    bottom 15%
    width calc(83% + 8px)

    &.regular
      bottom auto

  &__arrow 
    width 24px
    display flex 
    align-items center
    justify-content center

    svg
      .cls-11
        fill none
        stroke #fff
        stroke-miterlimit 10
        stroke-width 2.5px
      .cls-12
        fill #fff

</style>


